import styled from "styled-components";

interface TypographyBoxProps {
	color: string;
}

export const TypographyBox = styled.div.withConfig({
	shouldForwardProp: (prop) => !["color"].includes(prop),
})<TypographyBoxProps>`
	width: 1200px;
	margin: 0 auto;
	padding: 12px;
	box-sizing: border-box;
	color: #333;
	background-color: ${(props: TypographyBoxProps) => props.color};
	& > div {
		overflow: hidden;
		padding: 0;
		margin: 0;
	}
`;
